export const SERVICES = [
  {
    n: "01",
    slug: "graphic-design",
    title: "Graphic Design",
    short: "Visual communication that is clear, striking and on-brand.",
    intro:
      "Considered graphics for every touchpoint — from a single poster to a full set of campaign assets — built to communicate quickly and look unmistakably yours.",
    items: ["Marketing graphics", "Posters and promotional materials", "Social media graphics", "Editorial layouts", "Advertising creatives", "Visual communication materials"],
    image: "campaign",
    alt: "Concept poster series in royal blue and electric lime pasted on a brick wall",
    theme: "light",
    layout: "split",
  },
  {
    n: "02",
    slug: "logo-design",
    title: "Logo Design",
    short: "Marks and wordmarks designed to be remembered.",
    intro:
      "A logo is the most-used asset a business owns. We explore concepts, refine the strongest direction and test it across real applications before it is final.",
    items: ["Custom logo concepts", "Wordmarks and brand marks", "Logo variations", "Brand application concepts", "Logo presentation mockups"],
    image: "tech",
    alt: "Concept geometric logo mark applied to a poster, laptop, t-shirt and ID badge",
    theme: "navy",
    layout: "split",
    reverse: true,
  },
  {
    n: "03",
    slug: "branding-visual-identity",
    title: "Branding and Visual Identity",
    short: "Complete identity systems with colour, type and guidelines.",
    intro:
      "Identity is more than a logo. We build the colour, typography and rules that keep every channel consistent, recognisable and easy to use.",
    items: ["Brand identity development", "Colour palette selection", "Typography systems", "Brand guidelines", "Visual consistency across marketing channels"],
    image: "identity",
    alt: "Concept stationery set with navy envelopes, blue cards and a bold wordmark",
    theme: "mist",
    layout: "stacked",
  },
  {
    n: "04",
    slug: "brochures-marketing-materials",
    title: "Brochures and Marketing Materials",
    short: "Print and presentation design with editorial polish.",
    intro:
      "Brochures, profiles and presentations designed with a clear editorial grid, confident typography and print-ready precision.",
    items: ["Company brochures", "Business profiles", "Flyers and leaflets", "Corporate presentations", "Promotional materials", "Print-ready design layouts"],
    image: "brochure",
    alt: "Concept corporate brochure spread with blue duotone photography and bold headings",
    theme: "light",
    layout: "split",
    reverse: true,
  },
  {
    n: "05",
    slug: "packaging-design",
    title: "Packaging Design",
    short: "Packaging that earns attention on the shelf.",
    intro:
      "Packaging concepts, labels and graphics that tell a product’s story at a glance and stay consistent across an entire range.",
    items: ["Product packaging concepts", "Label design", "Packaging graphics", "Product presentation mockups", "Visual consistency across product ranges"],
    image: "packaging",
    alt: "Concept luxury skincare packaging in matte navy with lime detailing on a stone plinth",
    theme: "navy",
    layout: "split",
  },
  {
    n: "06",
    slug: "website-design",
    title: "Website Design",
    short: "Business websites with a strong visual direction.",
    intro:
      "Website layouts and landing pages that carry your brand online — planned for every screen size and designed to guide visitors to act.",
    items: ["Website visual layouts", "Landing page design", "Business website design concepts", "Responsive design planning", "Website visual direction"],
    image: "website",
    alt: "Concept landing page design shown on a laptop with floating interface panels",
    theme: "light",
    layout: "stacked",
  },
  {
    n: "07",
    slug: "ui-digital-design",
    title: "UI and Digital Design",
    short: "Interfaces and design systems built around people.",
    intro:
      "Clean, user-focused interfaces backed by reusable components, so digital products look consistent and are easier to build and grow.",
    items: ["User interface design", "Website interface concepts", "Digital visual assets", "Design systems and reusable components", "User-focused visual layouts"],
    image: "mobile",
    alt: "Concept mobile app interface shown on three floating smartphones",
    theme: "mist",
    layout: "split",
    reverse: true,
  },
  {
    n: "08",
    slug: "digital-content-creation",
    title: "Digital Content Creation",
    short: "Branded content for social, ads and campaigns.",
    intro:
      "A steady stream of on-brand digital content — social posts, ads and campaign assets — designed to perform in the feed and stay true to the brand.",
    items: ["Social media content", "Digital advertisements", "Online promotional graphics", "Campaign visual assets", "Branded digital content"],
    image: "restaurant",
    alt: "Concept restaurant brand assets including menus, napkins and a tote bag",
    theme: "navy",
    layout: "split",
  },
];
